<template>
  <v-card
    class="project-card"
    :class="{
      'justify-space-between' :project.status,
      'project-card--pinned': project.pinned,
      'project-card--selected': selected,
    }"
    width="100%"
    height="100%"
  >
    <div class="w-100">
      <div class="d-flex justify-space-between w-100">
        <ProjectAvatar
          class="mb-2"
          :project="project"
        />

        <div class="d-flex flex-column justify-space-between align-center mr-n3">
          <ProjectCardMenu
            v-if="!selectable"
            :project="project"
            :deletable="deletable"
            @delete="deleteProject"
          />

          <span
            v-else
            class="project-card__checkbox"
            :class="{ 'project-card__checkbox--selected': selected }"
            @click="selectElement"
          >
            <v-icon
              v-if="selected"
              color="white"
              small
            >mdi-check-bold</v-icon>
          </span>
          <ProjectActionsBell :project="project" />
        </div>
      </div>
      <router-link :to="projectDetailsRoute(project)">
        <h6 class="project-card__header underlined-hover">
          {{ project.name }}
        </h6>
      </router-link>

      <div class="project-card__info-text">
        ID: {{ project.id }}
      </div>

      <div class="project-card__info-text">
        {{ dateRange(project) }}
      </div>

      <div class="project-card__info-text">
        {{ project.projectType }}
      </div>

      <AppLimitedItems
        v-if="project.campaigns"
        class="text-body-2 golden--text font-weight-medium mt-1"
        :items="project.campaigns"
      />

      <hr class="project-card__divider my-3">
    </div>

    <AppAvatarsGroup
      :team="project.members"
      team-name="Zespół projektowy"
    />

    <AppAvatarsGroup
      :team="project.orderers"
      team-name="Zespół zlecający"
    />

    <AppStatus
      v-if="project.status"
      class="mt-4"
      :status-text="project.status"
    />
  </v-card>
</template>

<script>
import AppStatus from '@/components/UI/AppStatus.vue';
import AppAvatarsGroup from '@/components/UI/AppAvatarsGroup.vue';
import ProjectCardMenu from '@/components/Projects/ProjectCardMenu.vue';
import ProjectActionsBell from '@/components/Projects/ProjectActionsBell.vue';
import ProjectAvatar from '@/components/Projects/ProjectAvatar.vue';
import AppLimitedItems from '@/components/UI/AppLimitedItems.vue';
import projectFormattedInfo from '@/mixins/projectFormattedInfo.vue';

export default {
  components: {
    ProjectCardMenu,
    ProjectActionsBell,
    AppAvatarsGroup,
    ProjectAvatar,
    AppStatus,
    AppLimitedItems,
  },

  mixins: [
    projectFormattedInfo, // dateRange, projectDetailsRoute, shortenTitle
  ],

  props: {
    project: {
      type: Object,
      required: true,
    },
    selectable: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    deletable: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    selectElement() {
      this.$emit('select', this.project.id);
    },
    deleteProject() {
      this.$emit('delete', this.project);
    },
  },
};
</script>
